import React from 'react';
import { useSelector } from "react-redux";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TIPO_COMPROBANTE } from '../../../utils/constants';

const useStyles = makeStyles({
    dialog: {
      alignSelf: 'start'
    }
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const ModalDetalleComp = ({open, close, comprobante}) => {
    const classes = useStyles();
    const { itemsSeleccionado } = useSelector((state) => state.facturasAfiliado);

    return ( 
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={close}
            aria-labelledby="form-dialog-title"
            classes={{ paper: classes.dialog }}
        >
            <DialogTitle id="form-dialog-title" style={{ paddingBottom: "0px" }}>
                Detalle Comprobante {comprobante?.nroComprobante}
            </DialogTitle>
            <DialogContent>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Nro Comprobante</TableCell>
                    <TableCell align="left">Tipo</TableCell>
                    <TableCell align="left">Periodo</TableCell>
                    <TableCell align="center" style={{minWidth: 100}}>Importe</TableCell>
                    <TableCell align="center">Saldo</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                    {itemsSeleccionado.map((item, i) => (
                        <TableRow key={i}>
                            <TableCell align="left">{new Date(item.fechaComprobante2).toLocaleString("es", optionsfecha)}</TableCell>
                            <TableCell align="left">
                                {item?.idTipoComprobante === TIPO_COMPROBANTE.FACTURA
                                    ?   item.nroComprobante2
                                    :   item.nroComprobante
                                }
                            </TableCell>
                            <TableCell align="left">{item.descripcionTipoComprobante}</TableCell>
                            <TableCell align="left">{item.periodo}</TableCell>
                            <TableCell align="center" style={{minWidth: 100}}>{item.importe}</TableCell>
                            <TableCell align="center">{item.nroComprobante2 === item.nroComprobante && item.saldo}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            </DialogContent>
            <DialogActions>
            <Button
                autoFocus
                onClick={close}
                color="primary"
            >
                CERRAR
            </Button>
            </DialogActions>
        </Dialog>
     );
}